import type { MeetingMinutesActionItem } from '@ai-meeting/shared'

/**
 * Clear assignee fields on items whose `assignee_id` is not in the project roster.
 *
 * Used after a project change once the new members list has loaded: people who
 * still belong stay selected; everyone else is wiped so the cell does not keep
 * advertising an id that can no longer be assigned.
 */
export function clearInvalidBacklogAssignees(
  items: MeetingMinutesActionItem[],
  validMemberIds: ReadonlySet<number>,
): { items: MeetingMinutesActionItem[]; changed: boolean } {
  let changed = false
  const nextItems = items.map((item) => {
    if (item.assignee_id == null || validMemberIds.has(item.assignee_id)) return item
    changed = true
    return { ...item, assignee: '', assignee_id: null }
  })
  return { items: nextItems, changed }
}
